import type { CanBuilder } from "../types";

export function definePublicRules(can: CanBuilder): void {
	can("read", "Principle");
	can("create", "Organization");
}
